//销毁单
export default [
    {   //销毁计划客户端列表
        path: "destory/plan/list",
        name: "destoryPlan",
        component: () => import(/* webpackChunkName: "destory" */ "@/views/destory/plan/index"),
    },
    {   //销毁计划编辑
        path: "destory/plan/update/:type",
        name: "destoryUpdate",
        component: () => import(/* webpackChunkName: "destory" */ "@/views/destory/plan/update/index.vue"),
    },
    {   //销毁计划管理端列表
        path: "destory/plan/admin/list",
        name: "destoryPlanAdmin",
        component: () => import(/* webpackChunkName: "destory" */ "@/views/destory/plan/admin/index"),
    },
    // 销毁单列表
    {
        path: "destory/order/list",
        name: "destoryOrder",
        component: () => import(/* webpackChunkName: "destory" */ "@/views/destory/order/index"),
    },
    // 销毁单编辑
    {
        path: "destory/order/update/:type",
        name: "destoryOrderUpdate",
        component: () => import(/* webpackChunkName: "destory" */ "@/views/destory/order/update"),
    }
]


